import { render } from "./MemberBenefit.vue?vue&type=template&id=661f7798&scoped=true"
import script from "./MemberBenefit.vue?vue&type=script&lang=js"
export * from "./MemberBenefit.vue?vue&type=script&lang=js"

import "./MemberBenefit.vue?vue&type=style&index=0&id=661f7798&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-661f7798"]])

export default __exports__